import React from 'react';
import { useToggleFullScreenCallback } from 'js/file_viewer/api/navigation';
import { useFileViewerContext } from 'js/file_viewer/contexts/file_viewer';
import { UserActionContext } from 'js/file_viewer/core/logging/constants';
import { useCurrentPreviewMetadata } from 'js/file_viewer/core/queries/preview_metadata';
import { PreviewType } from 'js/file_viewer/core/types/preview_type';
// Video fullscreen is handled by the native video player, so exclude that
const canFullScreenOnTouch = (previewType) => {
    return ![PreviewType.Video, PreviewType.Audio, PreviewType.Error, PreviewType.Loading].includes(previewType);
};
export const useToggleFullscreenOnTouch = () => {
    const { featureConfig } = useFileViewerContext();
    const previewMetadata = useCurrentPreviewMetadata();
    const isMobileWeb = featureConfig.mobile_web;
    const canFullScreen = canFullScreenOnTouch(previewMetadata.previewType);
    const toggleFullscreenCallback = useToggleFullScreenCallback();
    const toggleFullScreen = React.useCallback(() => {
        toggleFullscreenCallback({
            actionContext: UserActionContext.SurfaceGesture,
        });
    }, [toggleFullscreenCallback]);
    return canFullScreen && isMobileWeb ? toggleFullScreen : undefined;
};
//# sourceMappingURL=utils.preenvesnextjs.map
